import { SVGFC } from '@repo/toolkit/types'

const VideoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.6001 12.8329L20.3007 15.7346C20.3685 15.7763 20.4472 15.8003 20.5285 15.8039C20.6098 15.8075 20.6907 15.7906 20.7624 15.755C20.8342 15.7194 20.8942 15.6665 20.936 15.6019C20.9779 15.5372 21 15.4633 21 15.3879V8.5579C21 8.48459 20.9792 8.41257 20.9395 8.34911C20.8999 8.28565 20.8428 8.23301 20.7742 8.19649C20.7055 8.15997 20.6277 8.14087 20.5485 8.14112C20.4693 8.14136 20.3916 8.16095 20.3232 8.1979L15.6001 10.7496"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7998 7H4.79997C3.80588 7 3 7.74619 3 8.66667V15.3333C3 16.2538 3.80588 17 4.79997 17H13.7998C14.7939 17 15.5998 16.2538 15.5998 15.3333V8.66667C15.5998 7.74619 14.7939 7 13.7998 7Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default VideoIcon
